import styled, { css } from 'styled-components';

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

export const TextWrapper = styled.div`
  display: flex;
`;

export const Report = styled.button<{ $clickable: boolean }>`
  background-color: transparent;

  ${({ $clickable, theme }) =>
    $clickable &&
    css`
      color: ${theme.primary_300};
      text-decoration: underline;
      cursor: pointer;

      &:hover {
        opacity: 0.7;
      }
    `}
`;
